// src/index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './App.css';
import { SettingsProvider } from './context/SettingsContext'; // Importe o SettingsProvider

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <SettingsProvider> {/* Envolve o App com o SettingsProvider */}
        <App />
      </SettingsProvider>
    </BrowserRouter>
  </React.StrictMode>
);